import { postRequest } from "../helpers/fetchHandler"
import { FEEDBACK_LOADING, FEEDBACK_SUCCESS, FEEDBACK_FAILED } from "../constants/actionTypes"

export function postFeedback(data) {
  return async dispatch => {
    dispatch({ type: FEEDBACK_LOADING })

    const url = "/api/v1/feedback/"
    try {
      const response = await postRequest({ url, data, auth: true })
      dispatch({ type: FEEDBACK_SUCCESS, payload: response })
      return response
    } catch (error) {
      dispatch({ type: FEEDBACK_FAILED, error })
      throw error
    }
  }
}
